import {
  eventsLoading,
  eventsError,
  setEventsList,
} from "../../slices/eventsSlice";
import {
  getEvent,
  createEvent,
  deleteAllEvents,
  deleteRowService,
  updateEvent,
  softDeleteEvent,
  softDeleteAllEvents,
  restoreRowService,
  restoreAllEvents,
} from "../../services/events";

export const getAction = () => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await getEvent();
    if (response?.error) {
      dispatch(eventsError(response.error));
      return;
    } else {
      dispatch(setEventsList(response));
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await createEvent(formData);
    if (response?.error) {
      dispatch(eventsError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(eventsLoading());
  try {
    const response = await updateEvent(formData);

    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        eventsError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await softDeleteEvent(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        eventsError(`Failed to softdelete row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const softDeleteAllAction = (table, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await softDeleteAllEvents(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(eventsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        eventsError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const deleteAllAction = (table, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await deleteAllEvents(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(eventsError(`Failed to delete records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        eventsError(`Failed to recover row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};

export const restoreAllAction = (table, username) => async (dispatch) => {
  dispatch(eventsLoading());
  try {
    const response = await restoreAllEvents(table, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(eventsError(`Failed to recover records in ${table} table`));
      return;
    }
  } catch (error) {
    dispatch(eventsError(error.message));
    return;
  }
};
